module.exports = __webpack_public_path__ + "img/new.f7b674cf.png";